import { useId, useState } from 'react'
import { updateIncident } from '../../api/incidents'

interface IncidentVisibilityToggleProps {
  incidentId: string
  isPublic: boolean
  onUpdated: () => Promise<void>
  onSuccess: (message: string) => void
  onError: (message: string) => void
}

export function IncidentVisibilityToggle({ incidentId, isPublic, onUpdated, onSuccess, onError }: IncidentVisibilityToggleProps) {
  const [saving, setSaving] = useState(false)
  const descriptionId = useId()

  async function changeVisibility(nextPublic: boolean) {
    setSaving(true)
    try {
      await updateIncident(incidentId, { is_public: nextPublic })
      await onUpdated()
      onSuccess(nextPublic ? 'Incident published to the status page' : 'Incident removed from the status page')
    } catch (error) {
      onError(error instanceof Error ? error.message : 'Failed to update incident visibility')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="w-full mt-2">
      <label className="inline-flex items-center gap-2 text-sm font-medium text-text-primary">
        <input
          type="checkbox"
          checked={isPublic}
          disabled={saving}
          onChange={(event) => changeVisibility(event.target.checked)}
          aria-describedby={descriptionId}
          className="rounded border-border focus:ring-brand-primary disabled:opacity-50"
        />
        Public on status page{saving ? ' (saving…)' : ''}
      </label>
      <p id={descriptionId} className="mt-1 text-xs text-text-secondary">
        Publishes this incident’s title, severity, status, timestamps and public updates. Incidents are private until published.
      </p>
    </div>
  )
}
